import React from "react";
import { CSSProperties } from "react";

interface InstructionProps {
  count: number; // Determines the instruction to display
}

// Instructions array
const instructions: string[] = [
  "Set up channel up button",
  "Set up channel down button",
  "Set up volume up button",
  "Set up volume down button",
  "Set up number 0",
  "Set up number 1",
  "Set up number 2",
  "Set up number 3",
  "Set up number 4",
  "Set up number 5",
  "Set up number 6",
  "Set up number 7",
  "Set up number 8",
  "Set up number 9",
  "Set up power button",
  "Complete!",
];

const InstructionComponent: React.FC<InstructionProps> = ({ count }) => {
  const instruction = instructions[count % instructions.length]; // Wrap around if count exceeds the array length

  return (
    <div
      style={{
        ...styles.instructionBox,
        backgroundColor: count === 15 ? "#C8E6C9" : "#E3F2FD", // Light green for 15, light blue otherwise
        color: count === 15 ? "#2E7D32" : "#01579B", // Dark green text for 15, dark blue otherwise
      }}
    >
      <p style={styles.instructionText}>{instruction}</p>
    </div>
  );
};

const styles: { [key: string]: CSSProperties } = {
  instructionBox: {
    backgroundColor: "#E3F2FD", // Light blue background
    color: "#01579B", // Dark blue text
    borderRadius: "10px",
    padding: "20px",
    width: "350px",
    margin: "20px auto",
    textAlign: "center",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
    fontSize: "1rem",
    fontWeight: "500",
    lineHeight: "1.5",
  },
  instructionText: {
    margin: 0,
  },
};

export default InstructionComponent;
